import Request from './request'
import consts from '@/consts.js'

async function fetch (data) {
  return Request('get', 'api/stocks', data)
}

async function fetchOne (id) {
  // 获取单个
  return Request('get', 'api/stocks/' + id)
}

async function fetchAll (data) {
  // 获取全部
  if (!data) {
    data = {}
  }
  data.limit = consts.limitAll //获取全部

  return Request('get', 'api/stocks', data)
}

async function save (id, data) {
  // 编辑或新建数据（有id为编辑，没有id为新建）
  if (id) {
    return Request('post', 'api/stocks/edit?id=' + id, data)
  } else {
    return Request('post', 'api/stocks/add', data)
  }
}

async function del (id) {// 删除数据
  return Request('delete', "api/stocks/delete/" + id);
}

async function fetchAllForSelect (data) {
  if (!data) data = {}
  data.limit = consts.limitAll //获取全部
  // data.fieldFilter = [
  //     "id",
  //     "code",
  //     "name",
  //     "stock_area",
  //     "stock_roadway_setting",
  //     "stock_district_code",
  //     "position_name_display"
  // ]; //仅筛选少许必要字段

  return Request('get', 'api/stocks/select', data, false, false, true)
}

async function stockKdnSave(id,data) {
  return Request('post', "api/stocks/kdn-settings/" + id,data);
}

async function syncHuaManLouStocks() {
  return Request('get', "api/stocks/sync-hua-man-lou-stocks/");
}

async function fetchAllNoPaging(data) {
  if (!data) data = {};
  // data.limit = consts.limitAll; //获取全部
  return Request('post', "api/stocks/select", Object.assign({},data,{
    itemsPerPage: consts.limitAll,
    limit: consts.limitAll,
  }));
}

export default {
  fetch,
  fetchOne,
  fetchAll,
  save,
  fetchAllForSelect,
  del,
  stockKdnSave,
  syncHuaManLouStocks,
  fetchAllNoPaging,
}
